var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.mapHeight }),attrs:{"id":"default-map-container"}},[_c('map-view',{on:{"update-map":function($event){return _vm.$emit('update-map')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }